import styled, { spacing } from "@rentiohq/web-theme";

export const InfoBox = styled.div<{ hasDocuments: boolean }>`
  ${({ hasDocuments }) =>
    hasDocuments ? "border-bottom: 1px solid lightgrey;" : ""}
  padding-bottom: ${spacing("base")};
`;
